export default "__VITE_ASSET__BQ3yNa3K__"